import './Header.css';

interface HeaderProps {
  children?: string;
}

function Header({ children }: HeaderProps): JSX.Element {
  return <h1 className="header">{children}</h1>;
}

export default Header;
